import { render } from "./otherReward.vue?vue&type=template&id=d86b47bc&scoped=true"
import script from "./otherReward.vue?vue&type=script&lang=js"
export * from "./otherReward.vue?vue&type=script&lang=js"

import "./otherReward.vue?vue&type=style&index=0&id=d86b47bc&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d86b47bc"]])

export default __exports__